import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13e6ac8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = {
  key: 0,
  class: "title-wrap"
}
const _hoisted_3 = { class: "input-wrap" }
const _hoisted_4 = {
  key: 0,
  class: "input-label"
}
const _hoisted_5 = { class: "buttons-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Hint = _resolveComponent("Hint")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Numpad = _resolveComponent("Numpad")!
  const _component_ActiveCall = _resolveComponent("ActiveCall")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dialing", _ctx.dialingClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.t(`${_ctx.dialingStatus}.title`) && !_ctx.settingsState.minimize)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_Button, {
              class: "get-back",
              iconOnly: "",
              size: "s",
              mode: "flat",
              icon: {name: 'ic20-chevron-left', width: '20px', height: '20px', color: '--sui-gray-900'},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openCallState(_ctx.currentSelectCallId || _ctx.currentActiveCallId)))
            }),
            _createVNode(_component_Typography, { class: "title" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t(`${_ctx.dialingStatus}.title`)), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.settingsState.minimize && _ctx.dialingStatus === 'firstCall')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_Typography, {
                class: "label-title",
                fontSize: "14px",
                fontWeight: "medium"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t(`${_ctx.dialingStatus}.inputTitle`)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Hint, {
                text: _ctx.t('firstCall.placeholder')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    spriteUrl: "static/icons-pack.svg",
                    name: "ic16-question",
                    width: "16",
                    height: "16"
                  })
                ]),
                _: 1
              }, 8, ["text"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_Input, {
          class: "input",
          id: "dialing-input",
          ref: "phoneNumberInput",
          clearable: "",
          state: _ctx.phoneInput.state,
          caption: _ctx.phoneInput.state === 'error' ? _ctx.t('error') : '',
          modelValue: _ctx.phoneInput.inputValue,
          placeholder: _ctx.settingsState.minimize ? _ctx.t(`${_ctx.dialingStatus}.inputTitle`) : '',
          "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => _ctx.changeInputValue({ value, event: 'change' })),
          onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.phoneInput.inputValue ? _ctx.actionOnBtn('primary') : _ctx.changeInputState('error')), ["native","enter"]))
        }, null, 8, ["state", "caption", "modelValue", "placeholder"])
      ])
    ]),
    (!_ctx.settingsState.minimize)
      ? (_openBlock(), _createBlock(_component_Numpad, {
          key: 0,
          class: _normalizeClass(["numpad-dialing", {'active-call': _ctx.callsStore.length}]),
          numpadButtonList: _ctx.numpadList,
          onClick: _cache[3] || (_cache[3] = (value) => _ctx.changeInputValue({ value, event: 'input' }))
        }, null, 8, ["class", "numpadButtonList"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Button, {
        class: "button",
        mode: _ctx.dialingStatus === 'toneDial' ? 'alert' : 'success',
        icon: { name: _ctx.dialingStatus === 'toneDial' ? 'ic20-phone-missed' : 'ic20-phone', color: '--sui-white' },
        iconOnly: _ctx.settingsState.minimize,
        onClick: _ctx.onToneDialClick
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.settingsState.minimize ? '' : _ctx.t(`${_ctx.dialingStatus}.buttonMain`)), 1)
        ]),
        _: 1
      }, 8, ["mode", "icon", "iconOnly", "onClick"]),
      (_ctx.showVideoButton)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "button",
            mode: "success",
            icon: { spriteUrl: 'static/icons-pack.svg', name: 'ic24-videocamera' },
            onClick: _cache[4] || (_cache[4] = () => _ctx.phoneInput.inputValue ? _ctx.actionOnBtn('video') : _ctx.changeInputState('error'))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('buttonVideoCall')), 1)
            ]),
            _: 1
          }, 8, ["icon"]))
        : _createCommentVNode("", true),
      (_ctx.showAdditionalButton && _ctx.dialingStatus !== 'firstCall')
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            class: "button",
            mode: "flat",
            onClick: _ctx.onAdditionalButton
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t(`${_ctx.dialingStatus}.buttonAdditional`)), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.settingsState.maximize && _ctx.selectCall?.status !== 'ENDED')
      ? (_openBlock(), _createBlock(_component_ActiveCall, {
          key: 1,
          class: "dialing-call-info"
        }))
      : _createCommentVNode("", true)
  ], 2))
}